import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCloudHumansReady } from "@/hooks/useCloudHumansReady";
import {
  setCloudHumansBubbleVisible,
  setCloudHumansUnreadPreview,
} from "@/utils/cloudHumans";

export const isCloudHumansBubbleRoute = (pathname: string) =>
  pathname === "/ajuda" || pathname.startsWith("/ajuda/");

export const useCloudHumansBubble = () => {
  const { pathname } = useLocation();
  const isChatReady = useCloudHumansReady();

  useEffect(() => {
    if (!isChatReady) return;
    const isBubbleRoute = isCloudHumansBubbleRoute(pathname);
    setCloudHumansBubbleVisible(isBubbleRoute);
    setCloudHumansUnreadPreview(isBubbleRoute);
  }, [pathname, isChatReady]);

  useEffect(
    () => () => {
      setCloudHumansBubbleVisible(false);
      setCloudHumansUnreadPreview(false);
    },
    [],
  );
};
